module.exports = __webpack_public_path__ + "img/interface OneB Studio_4 prew.1a0a0b32.jpg";